<template>
<main v-if="TicMv">

<div id="miraj-body">
<div class="mtbg" ><a href="/index"><img :src="imgPath+'images/mticketlogo.png'" alt="Image" style="width: 30%;" ></a>  </div>

<div class="mtbor">

<div class="mte" >

<div class="mthed">Booking Successful !!! </div>

<div class="text-center">
      <span class="admit">Invoice  No - </span>
      
 
        
        <span class="fotw" >  {{ TicMv.Serial }}</span>
  </div>

  <div class="text-center" style="padding-bottom: 20px;">
      <span class="admit">Ticket ID - </span>
      
 
        
        <span class="fotw" > {{ TicMv.resNo }}</span>
  </div>

    </div>



<div class="text-center" style="position: relative;"> 
  <!-- <img :src=TicMv.qrData   alt="" width="50%" style="width: 50%;" > -->
  <qrcode-vue :value=TicMv.qrData :size="size" level="H" />

</div>
<div style="padding-top: 15px; padding-left: 20px;padding-right: 20px;text-align: center;font-size: 12px;">Scan the QR code at the entrance of the cinema</div>
<div class="row">
  
<div class="col-6"><div class="sw" ></div></div>
<div class="col-6 text-end fullwid" >   <div class="se"></div> </div>
</div>




 </div>


<div class="mtall">

  <div class="row">
  
<div class="col-1"><div class="sw1" ></div></div>


<div class="col-10 mbord" > </div>


<div class="col-1 text-end fullwid">   <div class="se1" ></div> </div>

</div>

<div class="top mttoph">

<div class="mttoph1" >{{TicMv.movie}}</div>

      <span class="admit">Date &amp; Time - </span>
      
      <span class="num">
        
        <span class="fotw">{{TicMv.showDate}} | {{TicMv.showTime}} </span>
      </span>
    </div>

<div class="mtbord " ></div>




<div class="row mr-lr pdlrm" >
    <div class="col-6 col-md-6"> <span class="admit">Screen - </span>
      
      <span class="num fotw">
        
   {{TicMv.screen}}
      </span></div>
      <div class="col-6 col-md-6 text-end" >
      
      <span class="num fotw" >
        
        {{TicMv.mvlang}}

      </span></div>

</div>



<div class="row mr-lr" >
    <div class="col-6 col-md-6"> <span class="admit">Class - </span>
      
      <span class="num fotw">
        
        {{TicMv.seatclass}}
      </span></div>
      <div class="col-6 col-md-6 text-end" > <span class="admit">Amount - </span>
      
      <span class="num fotw" >
        
   {{TicMv.Amount}}
      </span></div>

</div>

<div class="row mr-lr pdlrm" >
    <div class="col-md-12"> <span class="admit">Location - </span>
      
      <span class="num fotw">
        
        {{TicMv.location}}
      </span></div>
      

</div>


   <div class="top" style="text-align: left;padding-top: 10px;padding-bottom: 10px;margin-left: 20px;">



      <span class="admit">Seats - </span>
      
      <span class="num">
        
        <span class="fotw">{{ TicMv.seats }}</span>
      </span>
    </div>



 <button id="btnX" style="border: none;background-color: white;color: #ec1f55;font-weight: 600;" @click="toggle">{{ ButtonText }}</button>

<div class="box dis" id="box">    
<div class="mtbord " style="padding-bottom: 5px;margin-top: 5px;"></div>


<div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> Net Charge :   </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{Rate.admin}}
      </span></div>

</div><div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> CGST  :   </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{ Rate.totgst/2 }}
      </span></div>

</div><div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> SGST  :    </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{ Rate.totgst/2 }}
      </span></div>

</div><div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> SC :    </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{ Rate.sc }}
      </span></div>

</div>
<div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> CESS :    </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{ Rate.cess }}
      </span></div>

</div><div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> ENT :    </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{Rate.entax}}
      </span></div>

</div>
<div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> Convenience fees :    </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw">
        
₹{{Rate.inh}}
      </span></div>

</div>
<div class="mtbord " style="padding-bottom: 5px;margin-top: 5px;"></div>

<div class="row mr-lr pt-5">
    <div class="col-8 col-md-8"> <span class="admit"> <b> Ticket Cost : </b>   </span>
    </div>
      <div class="col-4 col-md-4 text-end">
      
      <span class="num fotw mred" >
        
₹  {{TicMv.Amount}}
      </span></div>

</div>
<div style="padding-left: 20px;font-size:12px;"> GST : 32AANCP0020D1Z5 </div>




</div>
 </div>





<div class="marmt"> <img :src="imgPath+'images/1.png'" alt="" class="fullwid" >  </div>

<div class="marmt" v-if="FnB.length>0" > <img :src="imgPath+'images/2.png'" alt="" class="fullwid">  </div>
<div v-if="FnB.length>0" style="margin-left: 20px;margin-right: 20px;background-color: white;padding-top: 15px;padding-left: 20px;padding-right: 20px;padding-bottom: 15px;border-radius: 0px 0px 5px 5px;" > 



<div class="mfod" >Food and Beverage </div>


   


     <table class="fullwid" >

  <tbody><tr v-for="item in FnB" :key="item.pdt_name">
    <td> <span class="admit">{{item.qty}} x </span>
      
      <span class="num fotw">
        
{{ item.pdt_name }}
      </span></td>
    <td class="text-end" >{{item.unitprice}}</td>

  </tr> <tr style="border-top: dashed 1px black;margin-top: 15px;">
    <td style="padding-top: 8px;color: #ed324f;"> 
      
      <span class="num fotw" >Total (GST Included)</span></td>
    <td style="text-align: end;padding-top: 8px;font-weight: 600;color: #ed2f50;">{{ calculateOverallTotal }}</td>

  </tr>
</tbody></table> 
<div style="padding-left: 3px;font-size:12px;"> GST : 32AAOFH5492D1ZC </div>



 </div>


<div class="mar20" style="text-align: center;"> <div style="color: white;font-size: 12px;font-weight: 200;">Box Office  Solution Powered By </div> <img alt="" :src="imgPath+'images/red.png'" class="" style="width: 46%;">  </div>


</div>


</main>
</template>
<script>
import { URL } from '@/conf';
import axios from 'axios';
import QrcodeVue from 'qrcode.vue'

export default {
data:()=>({
    TicMv:null,
    imgPath: process.env.BASE_URL,
    Rate:{},
    ButtonText:"View More",
    FnB:null,
    size:150

}),
methods:{
    toggle(){
  document.getElementById('box').classList.toggle("open-box");
  this.ButtonText=this.ButtonText=="View Less"?"View More":"View Less";
    },

    GetTicketDetails(){
        axios.post(URL + "Ticket-Details", { udf1:this.$route.params.showid}, {
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        }
      }).then((response)=>{
        this.TicMv=response.data.details;
        this.Rate=JSON.parse(this.TicMv.rate);
        this.FnB=response.data.FnB;

      });
    }
},
mounted(){
    this.GetTicketDetails();
},
computed: {
    calculateOverallTotal() {
      return this.FnB.reduce((total, item) => total + item.qty * item.unitprice, 0);
    },
  },
  components: {
      QrcodeVue,
    },

};
</script>
<style type="text/css" media="screen" scoped>#miraj-body {
    background: linear-gradient(135deg, rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%);
    margin: 0 auto;
    max-width: 420px;
    padding-bottom: 1%;
    position: relative;
    width: 100%;
  }
  
  
  .box {
   
    
  
    -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
  }
  
  .open-box {
      
    display: block!important;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;
  }
  
  button {
    display: block;
    margin: auto;
  }
  
  .dis{display: none;}
  .pt-5 {padding-top: 5px !important;}
  .mred{color: #ec1f55!important;}
  .qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
}

.qrcode__image {
  background-color: #fff;
  border: 3px solid #fff;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 35px;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 75px;
  transform: translate(-50%, -50%);
  width: 35px;
}
  </style>
